function readSchemaEntries(params: { namespace: string, object: string }) {
    const { namespace, object } = params;
    return window.apiCoreSingleton.get(`/api/admin/${namespace}/${object}/read`);
}

export { readSchemaEntries };
